import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import Icon from 'components/AppIcon';

  const Notification = ({ show, message, type, onClose, autoHideDuration = 10000, inModal = false }) => {
  const [borderColor, setBorderColor] = useState('');
  const [textColor, setTextColor] = useState('');
  const [iconName, setIconName] = useState('Info');

  useEffect(() => {
    if (show && autoHideDuration) {
      const timer = setTimeout(() => {
        onClose();
      }, autoHideDuration);
      return () => clearTimeout(timer);
    }
  }, [show, autoHideDuration, onClose]);

  useEffect(() => {
    switch (type) {
      case 'success':
        setBorderColor('border-green-500');
        setTextColor('text-green-400');
        setIconName('CheckCircle');
        break;
      case 'error':
        setBorderColor('border-red-500');
        setTextColor('text-red-400');
        setIconName('XCircle');
        break;
      case 'warning':
        setBorderColor('border-yellow-500');
        setTextColor('text-yellow-400');
        setIconName('AlertTriangle');
        break;
      case 'info':
      default:
        setBorderColor('border-blue-500');
        setTextColor('text-blue-400');
        setIconName('Info');
        break;
    }
  }, [type]);

  const variants = {
    hidden: { opacity: 0, y: 50, scale: 0.8 },
    visible: { opacity: 1, y: 0, scale: 1, transition: { type: "spring", damping: 15, stiffness: 100 } },
    exit: { opacity: 0, y: 50, scale: 0.8, transition: { duration: 0.2 } }
  };

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          initial="hidden"
          animate="visible"
          exit="exit"
          variants={variants}
          className={`${inModal ? 'absolute top-4 right-4 left-4' : 'fixed bottom-4 right-4'} p-4 rounded-lg shadow-lg flex items-center space-x-3 z-[1000] backdrop-blur-md ${borderColor} ${textColor}`}
          style={{
            background: 'linear-gradient(135deg, rgba(255,255,255,0.1) 0%, rgba(255,255,255,0.05) 100%)',
            boxShadow: 'inset 0 0 0 1px rgba(255, 255, 255, 0.1)'
          }}
        >
          <Icon name={iconName} size={20} className="flex-shrink-0" />
          <p className="flex-grow text-white">{message}</p>
          <button onClick={onClose} className="flex-shrink-0 text-white/70 hover:text-white">
            <Icon name="X" size={16} />
          </button>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default Notification;
